module.exports = __webpack_public_path__ + "img/recommendIcon1.135f19c6.gif";